import { createSlice } from "@reduxjs/toolkit";
import { startPayment, cancelPaypalPayment } from "../Services/payment.service";

interface PaymentLoad {
  loading: boolean;
  redirect: boolean;
}

const initialState: PaymentLoad = {
  loading: false,
  redirect: false,
};

const paymentLoadSlice = createSlice({
  name: "paymentLoader",  
  initialState,
  reducers: {
    reset: (state) => {
      state.loading = false;
      state.redirect = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(startPayment.pending, (state) => {
        state.loading = true;  
      })
      .addCase(startPayment.fulfilled, (state) => {
        state.loading = false; 
      })
      .addCase(startPayment.rejected, (state) => {
        state.loading = false; 
      })
      .addCase(cancelPaypalPayment.fulfilled, (state) => {
        state.redirect = true;
      });
  },
});

export const { reset } = paymentLoadSlice.actions;  
export default paymentLoadSlice.reducer;